import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BadgeState, BadgeStore } from './badge.store';
import { SettingsQueryInterface } from '../../interfaces/settings/settings-query.interface';
import { TableColumn } from '../../models/table-column';
import { BadgeComponentsEnum } from '../../enums/badge-components.enum';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BadgeQuery
  extends Query<BadgeState>
  implements SettingsQueryInterface
{
  comeAndGo$ = this.select((state) => state.data?.comeAndGo);
  dayInfo$ = this.select((state) => state.data?.dayInfo);
  askForAbsence$ = this.select((state) => state.askForAbsence);
  settings$ = this.select((state) => state?.settings);

  constructor(protected store: BadgeStore) {
    super(store);
  }

  getSettings(): TableColumn[] {
    return this.getValue()?.settings;
  }

  isTileVisible(name: BadgeComponentsEnum) {
    return this.settings$.pipe(
      map(
        (list) =>
          !!list?.some((t) => t.name === name && t.selected && !t.disabled)
      )
    );
  }
}
